<template>
  <div class="kt-portlet kt-portlet--mobile">
    <div class="kt-portlet__head">
      <div class="kt-portlet__head-label">
        <h3 class="kt-portlet__head-title">Budget Plan — Email Monitoring</h3>
      </div>
      <div class="kt-portlet__head-toolbar">
        <router-link to="/BudgetPlan/Monitoring" class="btn btn-secondary btn-sm">
          <i class="fas fa-arrow-left"></i> กลับ
        </router-link>
      </div>
    </div>
    <div class="kt-portlet__body">
      <!-- Actions -->
      <div class="row mb-3">
        <div class="col-xl-3">
          <label>วันที่:</label>
          <input type="date" class="form-control" v-model="filterDate" />
        </div>
        <div class="col-xl-3">
          <label>สถานะ:</label>
          <select class="form-control" v-model="filterStatus">
            <option value="">ทั้งหมด</option>
            <option value="PENDING">PENDING</option>
            <option value="SUCCESS">SUCCESS</option>
            <option value="FAILED">FAILED</option>
          </select>
        </div>
        <div class="col-xl-6 d-flex align-items-end">
          <button class="btn btn-primary mr-2" @click="loadLogs">
            <i class="fas fa-search"></i> ค้นหา
          </button>
          <button class="btn btn-success mr-2" @click="triggerSend" :disabled="isSending">
            <i class="fas fa-paper-plane"></i> {{ isSending ? 'กำลังส่ง...' : 'Send Approval Group' }}
          </button>
        </div>
      </div>

      <!-- Result -->
      <div v-if="sendResult" class="alert" :class="sendResult.success ? 'alert-success' : 'alert-danger'">
        <strong>ส่งอีเมลแจ้งเตือน {{ sendResult.successCount }} ฉบับ</strong>
        (ผู้รับ {{ sendResult.successCount + sendResult.failedCount }} คน, สำเร็จ {{ sendResult.successCount }}, ล้มเหลว {{ sendResult.failedCount }})
        <br />
        <small>BatchCode: {{ sendResult.batchCode }}</small>
      </div>

      <!-- Table -->
      <div class="table-responsive">
        <table class="table table-sm table-striped table-bordered">
          <thead>
            <tr>
              <th class="text-center">#</th>
              <th class="text-center">BatchCode</th>
              <th>ผู้รับ</th>
              <th>อีเมล</th>
              <th class="text-center">ลำดับ</th>
              <th class="text-center">จำนวนใบงาน</th>
              <th>JobIds</th>
              <th class="text-center">ประเภท</th>
              <th class="text-center">สถานะ</th>
              <th class="text-center">วันที่ส่ง</th>
              <th>Error</th>
              <th class="text-center">Retry</th>
              <th class="text-center">คำสั่ง</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="logs.length === 0">
              <td colspan="13" class="text-center text-muted">ไม่พบข้อมูล</td>
            </tr>
            <tr v-for="(log, index) in logs" :key="log.id">
              <td class="text-center">{{ index + 1 }}</td>
              <td class="text-center"><small>{{ log.batchCode }}</small></td>
              <td>{{ log.recipientName }}</td>
              <td>{{ log.recipientEmail }}</td>
              <td class="text-center">{{ log.approvalLevel }}</td>
              <td class="text-center">{{ log.jobCount }}</td>
              <td><small>{{ log.jobIds }}</small></td>
              <td class="text-center">
                <span class="badge" :class="log.emailType === 'COMBINED' ? 'badge-primary' : 'badge-secondary'">
                  {{ log.emailType === 'COMBINED' ? 'รวมใบงาน' : 'แยกใบงาน' }}
                </span>
              </td>
              <td class="text-center">
                <span class="badge"
                  :class="{
                    'badge-warning': log.sendStatus === 'PENDING',
                    'badge-success': log.sendStatus === 'SUCCESS',
                    'badge-danger': log.sendStatus === 'FAILED'
                  }">
                  {{ log.sendStatus }}
                </span>
              </td>
              <td class="text-center">{{ log.sendDate ? formatDate(log.sendDate) : '-' }}</td>
              <td><small class="text-danger">{{ log.errorMessage }}</small></td>
              <td class="text-center">{{ log.retryCount }}</td>
              <td class="text-center">
                <button v-if="log.sendStatus === 'FAILED'"
                  class="btn btn-sm btn-outline-warning"
                  @click="retryEmail(log.id)"
                  title="Retry">
                  <i class="fas fa-redo"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      filterDate: "",
      filterStatus: "",
      logs: [],
      isSending: false,
      sendResult: null,
    };
  },
  mounted() {
    this.loadLogs();
  },
  methods: {
    loadLogs() {
      var self = this;
      var params = {};
      if (self.filterDate) params.date = self.filterDate;
      if (self.filterStatus) params.status = self.filterStatus;

      axios
        .get("/Api/BudgetPlan/ApprovalEmailLogs", { params })
        .then(function (response) {
          self.logs = response.data;
        })
        .catch(function (error) {
          console.error("Failed to load email logs:", error);
        });
    },
    triggerSend() {
      var self = this;
      self.isSending = true;
      self.sendResult = null;

      axios
        .post("/Api/BudgetPlan/SendApprovalGroup")
        .then(function (response) {
          self.sendResult = response.data;
          self.loadLogs();
        })
        .catch(function (error) {
          self.sendResult = {
            success: false,
            message: "เกิดข้อผิดพลาด: " + ((error.response && error.response.data && error.response.data.message) || error.message),
          };
        })
        .finally(function () {
          self.isSending = false;
        });
    },
    retryEmail(logId) {
      var self = this;
      axios
        .post("/Api/BudgetPlan/RetryApprovalEmail/" + logId)
        .then(function () {
          self.loadLogs();
        })
        .catch(function (error) {
          alert("Retry failed: " + error.message);
        });
    },
    formatDate(dateStr) {
      if (!dateStr) return "-";
      var d = new Date(dateStr);
      return d.toLocaleDateString("th-TH") + " " + d.toLocaleTimeString("th-TH");
    },
  },
};
</script>



// WEBPACK FOOTER //
// App/Components/BudgetPlan/BudgetPlanMonitoringSendApprovalGroup.vue